import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { theme } from './theme';
import HomePage from './components/HomePage';
import GamePage from './components/GamePage';
import GameEndPage from './components/GameEndPage';
import LeaderboardPage from './components/LeaderboardPage';
import Footer from './components/Footer';
import { LanguageProvider } from './translations/LanguageContext';
import { LanguageSwitcher } from './components/LanguageSwitcher';

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ 
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}>
          <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 1000 }}>
            <LanguageSwitcher />
          </Box>
          <Router>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/game" element={<GamePage />} />
              <Route path="/game-end" element={<GameEndPage />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
            </Routes>
            <Footer />
          </Router>
        </Box>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
